import './App.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import { ContentContainer, LayoutContainer } from './styles/Layout.style'
import Header from './components/Header/Header'
import { useState, useEffect } from 'react'
import Footer from './components/Footer/Footer'
import About from './pages/About'
import ContactUsPage from './pages/ContactUs'
import Lines from './pages/Lines'
import ConstructionPage from './pages/Construction'
import JoinTeam from './pages/JoinTeam'
import Product from './pages/Product'
import EuphaWorld from './pages/EuphaWorld'
import DoctorDirectory from './pages/DoctorDirectory'
import BlogPost from './pages/BlogPost'
import User from './pages/User'
import SignUp from './pages/SignUp'
import api from './services/api'

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setIsLoggedIn(true);
      setUser(userData);
    }
  }, []);

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    localStorage.removeItem('user');
  };

  const ProtectedRoute = ({ children }) => {
    return isLoggedIn ? children : <Navigate to="/login" />;
  };

  return (
    <LayoutContainer>
      <Header isLoggedIn={isLoggedIn} username={user?.name || user?.username} onLogout={handleLogout} />
      <ContentContainer>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/sobre-nosotros' element={<About />} />
          <Route path='/contacto/contacto' element={<ContactUsPage />} />
          <Route path='/en-construccion' element={<ConstructionPage />} />
          <Route path='/contacto/unete-al-equipo' element={<JoinTeam />} />
          <Route path='/eupha-world' element={<EuphaWorld />} />
          <Route path='/eupha-world/:idPost' element={<BlogPost />} />
          <Route path='/eupha-world/directorio-medico' element={<DoctorDirectory />} />
          <Route path='/login' element={<User onLogin={handleLogin} user={user} />}  />
          <Route path='/sign-up' element={<SignUp />} />
          
          {/* Protected Routes */}
          <Route path='/lineas' element={<Lines />} />
          <Route path='/lineas/:lineId/:subCategory/:productId' element={<ProtectedRoute><Product /></ProtectedRoute>} />
        </Routes>
      </ContentContainer>
      <Footer />
    </LayoutContainer>
  )
}

export default App
